/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useMemo } from 'react';
import DynamicSearchSelect from '../form-control/form-builder/form-builder-element/dynamic-select';
import { useUomFieldUpdater } from '../../hooks/useUomFieldUpdater';
import { useFormContext } from 'react-hook-form';

interface UomFieldWrapperProps {
    label: string;
    name?: string;
    placeholder?: string;
    fieldArrayName?: string;
    required?: boolean;
    is_loading?: boolean;
    disabled?: boolean;
    selectedItem: any;
    selectedUom?: any;
    fieldMapping?: Record<string, string>;
    customeFilter?: Record<string, any>;
    getSelectedData?: (data: any, name: string) => void;
    fieldPrefix?: string;
    setValue?: any;
    control?: any;
    isConversationFactor?: boolean;
    active_location?: any;
}

const UomFieldWrapper: React.FC<UomFieldWrapperProps> = ({
    label,
    name = 'uom_id',
    placeholder,
    fieldArrayName,
    required = false,
    is_loading = false,
    disabled = false,
    selectedItem,
    fieldMapping = {
        'total_on_hand_quantity': 'on_hand_quantity',
        'total_available_quantity': 'available_quantity',
        'total_committed_quantity': 'committed_quantity',
    },
    customeFilter,
    getSelectedData,
    fieldPrefix,
    setValue,
    control,
    isConversationFactor = true,
    active_location
}) => {
    // const selectedUom = useMemo(() => getValues(`${fieldArrayName}.${name}`), [getValues(`${fieldArrayName}.${name}`)])

    const [uomDetails, setUomDetails] = useState<any>(null);
    const formContext = useFormContext()
    const {
        control: contextControl,
        setValue: contextSetValue,
    } = formContext || {};

    const effectiveFieldPrefix = fieldPrefix !== undefined ? fieldPrefix : fieldArrayName || '';
    const finalFieldMapping = useMemo(() => fieldMapping,
        //eslint-disable-next-line
        [JSON.stringify(fieldMapping)]);

    const handleUomChange = useUomFieldUpdater({
        fieldMapping: finalFieldMapping,
        sourceData: selectedItem,
        conversation_factor: uomDetails?.conversation_factor,
        fieldPrefix: effectiveFieldPrefix,
        setValue: setValue || contextSetValue,
        control: control || contextControl,
        active_location: active_location,
        // shouldUpdate: !!selectedUom
    });

    useEffect(() => {
        if (!isConversationFactor) return;
        handleUomChange();
        // eslint-disable-next-line
    }, [handleUomChange, isConversationFactor]);

    const handleUomSelect = (data: any, name: string) => {
        setUomDetails(data);
        getSelectedData?.(data, name);
    };

    const effectiveCustomeFilter = customeFilter || {
        '&template_id.eq': selectedItem?.unit_of_measurement || 0
    };

    return (
        <DynamicSearchSelect
            label={label}
            name={name}
            placeholder={placeholder || ''}
            fieldArrayName={fieldArrayName || ''}
            formControl={control}
            required={required}
            is_loading={is_loading}
            disabled={disabled}
            apiType='uom'
            customeFilter={effectiveCustomeFilter}
            getSelectedData={handleUomSelect}
        />
    );
};

export default UomFieldWrapper;
